var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"welcome"},[_c('TopBar',{attrs:{"title":"肾小智"}}),_c('div',{staticClass:"little-person"},[_c('Hint')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }